/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
import { alCallProperty } from '../runtime';
import { wrapAVM1NativeClass } from './AVM1Utils';
import { AVM1Object } from '../runtime/AVM1Object';
import { AVM1Globals } from './AVM1Globals';
import { MouseEvent } from '@awayjs/scene';
var AVM1Mouse = /** @class */ (function (_super) {
    __extends(AVM1Mouse, _super);
    function AVM1Mouse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1Mouse.createAVM1Class = function (context) {
        var wrapped = wrapAVM1NativeClass(context, false, AVM1Mouse, ['show', 'hide'], []);
        return wrapped;
    };
    AVM1Mouse.bindStage = function (context, cls, avmStage, htmlElement) {
        var stage = avmStage.view.stage;
        if (AVM1Mouse.mouseDownDelegate)
            stage.removeEventListener(MouseEvent.MOUSE_DOWN, AVM1Mouse.mouseDownDelegate);
        if (AVM1Mouse.mouseMoveDelegate)
            stage.removeEventListener(MouseEvent.MOUSE_MOVE, AVM1Mouse.mouseMoveDelegate);
        if (AVM1Mouse.mouseOutDelegate)
            stage.removeEventListener(MouseEvent.MOUSE_OUT, AVM1Mouse.mouseOutDelegate);
        if (AVM1Mouse.mouseUpDelegate)
            stage.removeEventListener(MouseEvent.MOUSE_UP, AVM1Mouse.mouseUpDelegate);
        AVM1Mouse.mouseDownDelegate = function (e) {
            alCallProperty(cls, 'broadcastMessage', ['onMouseDown']);
        };
        AVM1Mouse.mouseMoveDelegate = function (e) {
            alCallProperty(cls, 'broadcastMessage', ['onMouseMove']);
        };
        AVM1Mouse.mouseOutDelegate = function (e) {
            alCallProperty(cls, 'broadcastMessage', ['onMouseOut']);
        };
        AVM1Mouse.mouseUpDelegate = function (e) {
            alCallProperty(cls, 'broadcastMessage', ['onMouseUp']);
        };
        stage.addEventListener(MouseEvent.MOUSE_DOWN, AVM1Mouse.mouseDownDelegate);
        stage.addEventListener(MouseEvent.MOUSE_MOVE, AVM1Mouse.mouseMoveDelegate);
        stage.addEventListener(MouseEvent.MOUSE_OUT, AVM1Mouse.mouseOutDelegate);
        stage.addEventListener(MouseEvent.MOUSE_UP, AVM1Mouse.mouseUpDelegate);
    };
    AVM1Mouse.hide = function () {
        AVM1Globals.instance.Stage.avmStage.mouseManager.showCursor = false;
    };
    AVM1Mouse.show = function () {
        AVM1Globals.instance.Stage.avmStage.mouseManager.showCursor = true;
    };
    AVM1Mouse.mouseDownDelegate = null;
    AVM1Mouse.mouseMoveDelegate = null;
    AVM1Mouse.mouseOutDelegate = null;
    AVM1Mouse.mouseUpDelegate = null;
    AVM1Mouse.mouseMiddleDownDelegate = null;
    AVM1Mouse.mouseMiddleUpDelegate = null;
    AVM1Mouse.mouseMiddleDownClicked = false;
    return AVM1Mouse;
}(AVM1Object));
export { AVM1Mouse };
